(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hbh-selection-summary"] && !Shopify.designMode) return;
  try {
    (function () {

    'use strict';

    if (window.customElements && customElements.get('selection-summary')) { return; }

    /* Deliberately narrow. A loose selector drags the wrong node in, and the

       node gets MOVED, so a wrong guess is visible immediately. */

    var FALLBACKS = [
      '[data-hbh-sku]', '.hbh-sku', '.hbh-sku-row', '[data-sku-row]',
      '[data-sku]', '.hbh-meta__sku', '.product-sku', '.sku-row'
    ];

    function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

    class SelectionSummary extends HTMLElement {

      connectedCallback() {

        if (this.__init) { return; }

        this.__init = true;

        this.run = this.querySelector('[data-sel-run]');

        this.slotEl = this.querySelector('[data-sku-slot]');

        try {

          this.data = JSON.parse(this.querySelector('[data-sel-map]').textContent);

        } catch (e) {

          this.data = { names: [], variants: {} };

        }

        this.form = this.closest('form[action*="/cart/add"]')

                 || document.querySelector('form[action*="/cart/add"]');

        /* Scope every DOM search to this product's own section. A page can

           carry more than one SKU row — the theme editor, a quick-view

           drawer, a recommended-products block — and a document-wide query

           lets one block MOVE another product's row into itself. */

        this.scope = this.closest('.shopify-section')

                  || this.closest('[id^="shopify-section"]')

                  || this.form

                  || document;

        this.merge();

        this.bind();

        this.sync();

      }

      /* --- move the theme's SKU row in, rather than re-rendering it --- */

      merge() {

        if (this.dataset.merge !== 'true') { return; }

        if (this.slotEl.firstElementChild) { return; }   /* already merged */

        var node = null;

        var sel = (this.dataset.skuSelector || '').trim();

        if (sel) { try { node = this.scope.querySelector(sel); } catch (e) { node = null; } }

        for (var i = 0; i < FALLBACKS.length && !node; i++) {

          node = this.scope.querySelector(FALLBACKS[i]);

        }

        if (!node) { node = this.findBySku(); }

        if (!node) { return; }

        /* The SKU lives in a theme block of its own. Move the WHOLE block
           wrapper, not whichever element we happened to match — a bare value
           span carries none of the row's markup, which is what produced an
           empty box on the first attempt. */
        node = node.closest('.shopify-block')
            || node.closest('[id^="shopify-block"]')
            || node;

        /* Guards: never swallow an ancestor of ourselves, never take a row
           another block has already claimed, and never swallow anything

           holding the buy button or a variant control. */

        if (node.contains(this)) { return; }

        if (node.closest('selection-summary')) { return; }

        if (node.querySelector('[name="add"], button[type="submit"], [name="id"]')) { return; }

        /* Remember where it came from. If the theme editor removes this

           block, the row goes back where it was instead of vanishing with us. */

        this.home = { parent: node.parentNode, prev: node.previousSibling, next: node.nextSibling };

        this.slotEl.appendChild(node);

        this.slotEl.hidden = false;

      }

      /* Auto-detect: the smallest element whose visible text IS the current

         SKU, then step up to the row that also holds the copy control. */

      findBySku() {

        var rec = this.data.variants[this.currentId()];

        var sku = rec && rec.sku;

        if (!sku) { return null; }

        var all = this.scope.querySelectorAll('*');

        var best = null;

        for (var i = 0; i < all.length; i++) {

          var el = all[i];

          if (el.children.length) { continue; }        /* leaf nodes only */

          if (txt(el) !== sku) { continue; }

          best = el;

          break;

        }

        if (!best) { return null; }

        var up = best;

        for (var h = 0; h < 3 && up.parentElement; h++) {

          up = up.parentElement;

          if (up.querySelector('button, [role="button"]')) { return up; }

        }

        return best;

      }

      currentId() {

        var input = this.form && this.form.querySelector('[name="id"]');

        return input ? String(input.value || '') : '';

      }

      sync() {

        var id = this.currentId();

        var rec = this.data.variants[id];

        if (!rec) { return; }

        if (id === this.__lastId) { return; }

        this.__lastId = id;

        var names = this.data.names || [];

        var vals = rec.o || [];

        var html = '';

        for (var i = 0; i < vals.length; i++) {

          var v = vals[i];

          if (v === null || v === undefined || v === '') { continue; }

          if (html) { html += '<span class="hbh-sel__sep" aria-hidden="true">·</span>'; }

          html += '<span class="hbh-sel__pair"><span class="hbh-sel__k">'

                + this.esc(names[i] || '') + '</span> <b>' + this.esc(v) + '</b></span>';

        }

        if (html) { this.run.innerHTML = html; }

      }

      esc(s) {

        return String(s).replace(/[&<>"']/g, function (c) {

          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];

        });

      }

      /* The theme updates the variant input asynchronously and by different

         routes depending on the picker, so rather than guess which event

         fires we re-read the input shortly after any interaction. sync() is

         a no-op when the id has not changed, so this stays cheap.

         merge() is retried too — a section re-render can put the theme's own

         SKU row back where it was. */

      bind() {

        var self = this;

        var soon = function () {

          requestAnimationFrame(function () { self.merge(); self.sync(); });

          setTimeout(function () { self.merge(); self.sync(); }, 120);

          setTimeout(function () { self.merge(); self.sync(); }, 400);

        };

        var scope = this.form || document;

        scope.addEventListener('change', soon);

        scope.addEventListener('click', soon);

        document.addEventListener('variant:update', soon);

        document.addEventListener('variantChange', soon);

        document.addEventListener('shopify:section:load', soon);

        var input = this.form && this.form.querySelector('[name="id"]');

        if (input && window.MutationObserver) {

          this.obs = new MutationObserver(soon);

          this.obs.observe(input, { attributes: true, attributeFilter: ['value'] });

        }

      }

      disconnectedCallback() {

        if (this.obs) { this.obs.disconnect(); this.obs = null; }

        var node = this.slotEl && this.slotEl.firstElementChild;

        var h = this.home;

        if (node && h && h.parent && h.parent.isConnected) {

          /* The siblings we recorded may themselves be gone by now — this

             element was usually one of them. Fall back down the chain rather

             than throwing, so the row is never lost. */

          var ref = null;

          if (h.prev && h.prev.parentNode === h.parent) { ref = h.prev.nextSibling; }

          else if (h.next && h.next.parentNode === h.parent) { ref = h.next; }

          else { ref = h.parent.firstChild; }

          try { h.parent.insertBefore(node, ref); } catch (e) {}

        }

        this.home = null;

      }

    }

    customElements.define('selection-summary', SelectionSummary);

  })();
  } catch(e) { console.error(e); }
})();

})();
